module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\">\n<path d=\"M12.25 3.5l3.5 3.5h12.25v19.25h-28v-22.75z\"></path>\n</svg>\n";